import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colorizeOption'
})
export class ColorizeOptionPipe implements PipeTransform {

  transform(value: string): unknown {
    return this.getCssClassFromStatus(value);
  }

  getCssClassFromStatus(state: string) {
    switch (state) {
      case 'ok':
        return 'option-ok';
      case 'warning':
        return 'option-warning';
      case 'error':
        return 'option-error';
      default:
        return '';
    }
  }
}
